import type { Theme } from '@mui/material';

export const styles = {
  contentWrapper: (theme: Theme) => ({
    px: 4,
    backgroundColor: theme.colors.neutral[50],
    width: '70%',
    overflowY: 'auto',
  }),

  content: (theme: Theme) => ({
    position: 'relative',
    backgroundColor: theme.colors.white,
    border: `1px solid ${theme.colors.neutral[200]}`,
    borderRadius: 2,
    height: '100%',
    p: 2,
  }),

  accordion: {
    boxShadow: 'none',
    border: 'none',
    p: '0 !important',

    '&:before': {
      content: 'none',
    },
  },

  accordionSummary: {
    padding: '0',
    justifyContent: 'flex-start',

    '> *': {
      flexGrow: '0 !important',
      mr: 1,
    },
  },

  accordionContent: (theme: Theme) => ({
    border: `1px solid ${theme.colors.neutral[200]}`,
    borderRadius: 2,
  }),
};
